import { ProductPickerType } from "@src/store/slices/productPicker/types";

const PRODUCT_PICKER_TYPES_WITH_INTELLIGEMS_PRODUCTS =
  new Set<ProductPickerType>([
    "customEvents",
    "analytics",
    "selectedAnalyticsProducts",
  ]);

// Analytics must be able to select every Shopify product identity that owns
// orders. Custom events also intentionally support Intelligems-created products.
export const shouldIncludeIntelligemsProducts = (
  type: ProductPickerType | undefined
): boolean =>
  type !== undefined &&
  PRODUCT_PICKER_TYPES_WITH_INTELLIGEMS_PRODUCTS.has(type);

const PRODUCT_PICKER_TYPES_THAT_BUILD_A_TEST_CART = new Set<ProductPickerType>([
  "cartTester",
  "agenticLogicCartTest",
]);

// A picker that builds a test cart picks variants, not just products: a cart
// line is one variant, so every multi-variant product opens expanded and
// counts its checked variants.
export const buildsTestCart = (type: ProductPickerType | undefined): boolean =>
  type !== undefined && PRODUCT_PICKER_TYPES_THAT_BUILD_A_TEST_CART.has(type);
